// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADDRESS = "Adresa";
export const CARD_TEXT = "Popis shopu";
export const EDIT_PROFILE_SETTINGS = "Zm\u011b\u0148 \u00fadaje";
export const EMAIL = "Email";
export const HEADING_MY_SHOP = "M\u016fj obchod";
export const PHONE = "Telefon";
export const VENDOR_NAME = "N\u00e1zev Va\u0161eho bazaru";
export const WEB = "Web";
